import { render, staticRenderFns } from "./educationTable.vue?vue&type=template&id=1088a1ca&scoped=true&"
import script from "./educationTable.vue?vue&type=script&lang=js&"
export * from "./educationTable.vue?vue&type=script&lang=js&"
import style0 from "./educationTable.vue?vue&type=style&index=0&id=1088a1ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1088a1ca",
  null
  
)

export default component.exports